// store.js
import Vue from 'vue';
import Vuex from 'vuex';
 
Vue.use(Vuex);
 
export default new Vuex.Store({
  state: {
    globalVar: 'initial value', // 定义全局变量
    lhSectionId: null, // 定义全局项目ID
    lhTunnelNumber: null, // 定义全局隧道编号
    lhTunnelName: null, // 定义隧道名称
    tmTunnelId: null, // 定义隧道ID
    tunneltype: null, // 定义隧道类型
    lhTunnelLength: null, // 定义总长度
    lhTunnelExcavation: null, // 定义挖掘长度
    lhTunnelArch: null, // 定义拱门距离
    lhTunnelSecondarylining: null, // 定义二开距离

    tunnelNumber: null,
    lhTunnelLatitude: null,
    lhTunnelLongitude: null,
    isTunnel: null,
    outputValue: null,
    lhTunnelLen: null,
    inclinedShaftLen: null,
    lhTunnelWidth: null,
    locationNum: null,
    monitortime: null,
    pileNoMark: null,
    speedLimit: null,
    startPointLocX: null,
    startPointLocY: null,
    totalOutputValue: null,
    beginTime: null,
    plannedEndTime: null,
  },
  mutations: {
    updateGlobalVar(state, newValue) {
        state.globalVar = newValue;
    },
    updateLhTunnelNumber(state, newValue) {
        state.lhTunnelNumber = newValue;
    },
    updateLhTunnel(state, JsonData) {
        state.lhSectionId = JsonData.lhSectionId; // 定义全局项目ID
        state.lhTunnelNumber = JsonData.lhTunnelNumber; // 定义全局隧道编号
        state.lhTunnelName = JsonData.lhTunnelName; // 定义隧道名称
        state.tmTunnelId = JsonData.tmTunnelId; // 定义隧道ID
        state.tunneltype = JsonData.tunneltype; // 定义隧道类型
        state.lhTunnelLength = JsonData.lhTunnelLength; // 定义总长度
        state.lhTunnelExcavation = JsonData.lhTunnelExcavation; // 定义挖掘长度
        state.lhTunnelArch = JsonData.lhTunnelArch; // 定义拱门距离
        state.lhTunnelSecondarylining = JsonData.lhTunnelSecondarylining; // 定义二开距离

        state.tunnelNumber = JsonData.tunnelNumber;
        state.lhTunnelLatitude = JsonData.lhTunnelLatitude;
        state.lhTunnelLongitude = JsonData.lhTunnelLongitude;
        state.isTunnel = JsonData.isTunnel;
        state.outputValue = JsonData.outputValue;
        state.lhTunnelLen = JsonData.lhTunnelLen;
        state.inclinedShaftLen = JsonData.inclinedShaftLen;
        state.lhTunnelWidth = JsonData.lhTunnelWidth;
        state.locationNum = JsonData.locationNum;
        state.monitortime = JsonData.monitortime;
        state.pileNoMark = JsonData.pileNoMark;
        state.speedLimit = JsonData.speedLimit;
        state.startPointLocX = JsonData.startPointLocX;
        state.startPointLocY = JsonData.startPointLocY;
        state.totalOutputValue = JsonData.totalOutputValue;
        state.beginTime = JsonData.beginTime;
        state.plannedEndTime = JsonData.plannedEndTime;
    }
  }
});